import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid2,
  Radio,
  Slider,
  Typography,
} from "@mui/material";
import React, { Fragment } from "react";
import CommonButton from "../../../../../component/Button";
import XCloseIco from "../../../../../assets/icons/XCloseIco";
import { CustomDiv } from "../../../../chat-bot/style";
import { Field, Form, Formik } from "formik";
import { CommonGrid2 } from "../../../../common-components/StyledComponents";
import * as Yup from "yup";
import CommonTextField from "../../../../../component/Input";
import { CustomizeSpan, ErrorContent } from "../../../../jobs/style";
import DropDownSelect from "../../../../../component/Select";
import CommonPhoneInput from "../../../../../component/PhoneInput";
import parsePhoneNumber from "libphonenumber-js";

export default function AddNewContact({
  contact,
  handleButttonClose,
  handleInformation,
  setFieldValue,
  contactValues,
}) {
  const initialValues = {
    name: contact.data?.name || "",
    contact_number: contact.data?.contact_number || "",
    email: contact.data?.email || "",
    nps_score: contact.data?.nps_score || "",
    nps_score_data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((item) => ({
      name: item,
      value: item,
    })),
    type: contact.data?.type || "",
    phone_country: contact.data?.phone_country || "",
    // primary_contact: false,
  };

  const validationSchema = Yup.object({
    type: Yup.string().required("Type is required"),
    name: Yup.string().required("Name is required"),
    contact_number: Yup.string()
      .nullable()
      .test(
        "is-valid-phone",
        "Phone number is not valid for the selected country",
        function (value) {
          const { phone_country } = this.parent;
          if (!value) return true;
          if (!phone_country?.countryCode) return true;

          const formattedValue = value.startsWith("+") ? value : `+${value}`;
          const phoneNumber = parsePhoneNumber(
            formattedValue,
            phone_country.countryCode
          );

          return phoneNumber?.isValid();
        }
      ),

    // nps_score: Yup.string().required("NPS Score is required"),
    // contact_number: Yup.string()
    //   .matches(/^(?!0+$)\d{10}$/, "Invalid Phone number")
    //   .required("Phone Number is required"),
    email: Yup.string()
      .required("Email is required")
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Invalid email address"
      ),
  });

  const keyContactData = [
    {
      title: "Name",
      component: "input",
      titleName: "name",
      placeholder: "Enter the Name",
      placeholderFontSize: "15px",
      mandatory: true,
    },
    {
      title: "Contact Number",
      component: "phone-number",
      fontSize: "15px",
      country: "phone_country",
      titleName: "contact_number",
      placeholder: "Enter the Contact Number",
      placeholderFontSize: "15px",
      mandatory: false,
    },

    // {
    //   title: "Contact Number",
    //   component: "input",
    //   titleName: "contact_number",
    //   placeholder: "Enter the Contact Number",
    //   placeholderFontSize: "15px",
    //   mandatory: false,
    // },
    {
      title: "Email Address",
      component: "input",
      titleName: "email",
      placeholder: "Enter the Email Address",
      placeholderFontSize: "15px",
      mandatory: true,
    },
    {
      title: "NPS Score",
      component: "slider",
      titleName: "nps_score",
      placeholder: "Select the NPS Score",
      mandatory: false,
    },
    {
      title: "Type",
      component: "input",
      titleName: "type",
      placeholder: "Enter the type",
      placeholderFontSize: "15px",
      mandatory: true,
    },
  ];

  const handleSubmit = (values) => {
    const { nps_score_data, ...rest } = values;
    const data = rest;
    handleInformation(data, setFieldValue, contactValues);
  };
  return (
    <Dialog
      fullWidth
      maxWidth={"sm"}
      open={contact.open}
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "10px",
        },
      }}
    >
      <DialogActions sx={{ justifyContent: "space-between" }}>
        <CustomDiv></CustomDiv>
        <Button onClick={handleButttonClose}>
          <XCloseIco />
        </Button>
      </DialogActions>

      <DialogContent style={{ textAlign: "center", paddingTop: "0px" }}>
        <Typography variant="h3" textAlign={"center"}>
          {"Add Information"}
        </Typography>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          validationSchema={validationSchema}
        >
          {({ values, handleChange, setFieldValue, errors, touched }) => {
            console.log(values, "sfklsnfklsfsklnlm");
            return (
              <Form>
                <Grid2 spacing={2} container size={12} marginTop={"1.5rem"}>
                  {keyContactData?.map((item, fieldIndex) => {
                    return (
                      <Grid2 key={fieldIndex} size={{ xs: 12, md: 6, sm: 6 }}>
                        <CommonGrid2
                          display={"flex"}
                          gap={"10px"}
                          flexDirection={"column"}
                          textAlign={"left"}
                        >
                          <Fragment>
                            <Typography
                              variant="h6"
                              fontSize={"16px"}
                              color={"#344054"}
                            >
                              {item.title}
                              {item.mandatory && (
                                <CustomizeSpan color={"red"}> *</CustomizeSpan>
                              )}
                            </Typography>

                            {item.component === "input" && (
                              <Field name={item.titleName}>
                                {({ field, form }) => {
                                  return (
                                    <CommonTextField
                                      {...field}
                                      placeholder={
                                        item?.placeholder || item.title
                                      }
                                      padding="12px"
                                      error={Boolean(
                                        form.touched?.[item.titleName] &&
                                          errors?.[item.titleName]
                                      )}
                                      helperText={
                                        form.touched?.[item.titleName] &&
                                        errors?.[item.titleName]
                                      }
                                      value={values[item.titleName]}
                                      onChange={(e) => {
                                        form.setFieldValue(
                                          item.titleName,
                                          e.target.value
                                        );
                                      }}
                                      placeholderFontSize={
                                        item?.placeholderFontSize
                                      }
                                    />
                                  );
                                }}
                              </Field>
                            )}

                            {item.component === "dropDown" && (
                              <Field name={item.titleName}>
                                {({ field, form }) => {
                                  return (
                                    <DropDownSelect
                                      marginTop="0px"
                                      title={
                                        item?.placeholder
                                          ? item?.placeholder
                                          : item.title
                                      }
                                      disabled={item?.disabled}
                                      removeAnimation={true}
                                      data={form.values[item.dropDownData]}
                                      error={Boolean(
                                        errors[item.titleName] &&
                                          form.touched?.[item.titleName]
                                      )}
                                      helperText={
                                        form.touched?.[item.titleName] &&
                                        errors[item.titleName]
                                      }
                                      value={values[item.titleName]}
                                      handleChange={(e) => {
                                        setFieldValue(
                                          item.titleName,
                                          e.target.value
                                        );
                                      }}
                                    />
                                  );
                                }}
                              </Field>
                            )}

                            {item.component === "slider" && (
                              <Field name={item.titleName}>
                                {({ field, form }) => {
                                  return (
                                    <Slider
                                      min={0}
                                      max={5}
                                      step={0.1}
                                      value={values[item.titleName]}
                                      valueLabelDisplay="auto"
                                      onChange={(_, newValue) =>
                                        setFieldValue(item.titleName, newValue)
                                      }
                                      sx={{
                                        height: "7px",
                                        "& .MuiSlider-rail": {
                                          backgroundColor: "#d1d2d4",
                                        },
                                        "& .MuiSlider-thumb": {
                                          width: 22,
                                          height: 22,
                                          backgroundColor: "#fff",
                                          border: "2px solid #7F56D9",
                                        },
                                        "& .MuiSlider-valueLabel": {
                                          backgroundColor: "#6941C6",
                                          fontSize: "13px",
                                          color: "white",
                                        },
                                      }}
                                    />
                                  );
                                }}
                              </Field>
                            )}
                            {item.component === "phone-number" && (
                              <Field name={item.titleName}>
                                {({ field, form }) => {
                                  const isError = Boolean(
                                    form.touched[item.titleName] &&
                                      form.errors[item.titleName]
                                  );
                                  return (
                                    <>
                                      <CommonPhoneInput
                                        placeholder={item?.placeholder}
                                        padding="14px 0px 14px 60px"
                                        country="us"
                                        value={values[item.titleName]}
                                        onChange={(e, countryData) => {
                                          setFieldValue(
                                            item.country,
                                            countryData
                                          );
                                          setFieldValue(item.titleName, e);
                                        }}
                                      />
                                      {isError && (
                                        <ErrorContent
                                          margin="-2px 0px 0px"
                                          className="Mui-error"
                                        >
                                          {form.errors[item.titleName]}
                                        </ErrorContent>
                                      )}
                                    </>
                                  );
                                }}
                              </Field>
                            )}
                          </Fragment>
                        </CommonGrid2>
                      </Grid2>
                    );
                  })}
                </Grid2>

                <CommonButton
                  value={"Add"}
                  width={"100%"}
                  padding={"10px"}
                  type="submit"
                  marginTop={"1.5rem"}
                  disabled={contact.loading}
                  loading={contact.loading}
                />
              </Form>
            );
          }}
        </Formik>
      </DialogContent>
    </Dialog>
  );
}
